import styled, { css } from 'styled-components';

export const InputBoxContainer = styled.div`
  &.in-filter .fa {
    right: 10px;
    top: 50%;
    margin-top: -8px;
    color: #000;
  }
`;

export const CalendarPlace = styled.div`
  position: absolute;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      z-index: 4000;
    `}
  /* Dark-theme fallback for the base (v1) calendar surfaces. In v2 the global
     CP calendar styling (cp-global.js) already paints these with the --cp-*
     tokens; here we mirror the CP dark palette (with hex fallbacks so v1 dark
     also renders correctly) so the redux-form calendar looks identical to the
     Formik one. No cyan/blue accents. */
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      .rc-calendar,
      .rc-calendar-year-panel,
      .rc-calendar-year-panel-body,
      .rc-calendar-date-panel,
      .rc-calendar-date-panel-body,
      .rc-calendar-time-picker,
      .rc-calendar-time-panel,
      .rc-calendar-time-panel-body,
      .rc-time-picker-panel-inner,
      .rc-time-picker-panel-select,
      .rc-calendar-month-panel,
      .rc-calendar-month-panel-body,
      .rc-calendar-decade-panel {
        background: var(--cp-surface, #161e23);
        color: var(--cp-text, #e6eaec);
      }
      .rc-time-picker-panel-select li:hover,
      .rc-calendar-date:hover {
        background: var(--cp-surface-hover, #232e35);
      }
    `}
`;

export const InputBox = styled.div`
  position: relative;
  i {
    position: absolute;
    top: 2px;
    right: 0px;
    color: var(--cp-text-secondary, #fff);
    opacity: 0.6;
  }
`;
